import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Sparkles, Coins, Loader2 } from "lucide-react";

export const AiDisclaimerGate = ({ active = true, onDecline }) => {
  const [status, setStatus] = useState(null);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!active) return;
    api.get("/auth/ai-disclaimer").then(r => setStatus(r.data)).catch(() => setStatus({ accepted: true }));
  }, [active]);

  if (!active || !status || status.accepted) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/auth/ai-disclaimer/accept");
      setStatus({ accepted: true });
    } finally { setBusy(false); }
  };
  const decline = () => { if (onDecline) onDecline(); else window.history.back(); };

  return (
    <div className="fixed inset-0 z-[80] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4" data-testid="ai-disclaimer-modal">
      <div className="bg-[#0a0e1a] border border-cyan-400/25 rounded-2xl max-w-lg w-full p-6 shadow-2xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-400/20 to-blue-500/10 border border-cyan-400/30 flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-cyan-300" />
          </div>
          <div>
            <h3 className="font-display text-lg font-bold text-white">AI Usage & Billing Disclosure</h3>
            <div className="text-[11px] text-slate-500">One-time acceptance required before using AI features</div>
          </div>
        </div>
        <div className="space-y-2.5 text-sm text-slate-300">
          <div className="flex gap-2.5"><Coins className="w-4 h-4 text-amber-300 mt-0.5 shrink-0" />
            <span>AI features — the Campaign Agent, Ask TotalReach Copilot, Creative Studio and Ad Studio — consume <strong className="text-white">AI tokens</strong>.</span></div>
          <div className="flex gap-2.5"><Coins className="w-4 h-4 text-amber-300 mt-0.5 shrink-0" />
            <span>AI tokens are billed <strong className="text-white">in addition to</strong> your subscription and media spend.</span></div>
          <div className="flex gap-2.5"><Coins className="w-4 h-4 text-amber-300 mt-0.5 shrink-0" />
            <span>Token usage is charged at the TotalReach rate, which includes a <strong className="text-white">+{status.ai_premium_pct ?? 40}% premium</strong> over raw provider cost.</span></div>
          <div className="flex gap-2.5"><Coins className="w-4 h-4 text-amber-300 mt-0.5 shrink-0" />
            <span>Itemized AI usage is available to your account admins at any time.</span></div>
        </div>
        <label className="flex items-start gap-2.5 mt-5 text-xs text-slate-400 cursor-pointer select-none">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)}
            className="mt-0.5 accent-cyan-400" data-testid="ai-disclaimer-checkbox" />
          <span>I understand that AI token usage is billed separately at a premium rate.</span>
        </label>
        <div className="mt-5 flex justify-end gap-2">
          <button onClick={decline} data-testid="ai-disclaimer-decline"
            className="px-4 py-2 rounded-md border border-white/10 text-slate-300 text-sm hover:border-white/25 transition-colors">
            Not now
          </button>
          <button onClick={accept} disabled={!checked || busy} data-testid="ai-disclaimer-accept"
            className="px-5 py-2 rounded-md bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-900 font-semibold text-sm disabled:opacity-40 inline-flex items-center gap-2">
            {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Accept & Continue
          </button>
        </div>
      </div>
    </div>
  );
};
